import React from 'react';
import { CheckIcon, MessageCircleIcon } from 'lucide-react';
import { WHATSAPP_MESSAGES } from '../config/siteConfig';
import { createWhatsAppUrl, trackEvent } from '../utils/analytics';
const benefits = ['Revisión de redes sociales.', 'Revisión de Google.', 'Análisis de la forma en que los clientes encuentran tu información.', 'Recomendación del tipo de página más conveniente.', 'Sin compromiso de compra.'];
export function DiagnosticSection() {
  return <section className="bg-[#050511] py-16 md:py-20" data-id="element-844">
      <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-8" data-id="element-845">
        <div className="grid gap-6 rounded-2xl border border-[#20d6e8]/25 bg-[#101022] p-6 md:grid-cols-[1.15fr_.85fr] md:p-8" data-id="element-846">
          <div data-id="element-847">
            <p className="text-sm font-semibold uppercase tracking-[0.16em] text-[#20d6e8]" data-id="element-848">
              ¿No sabés qué necesita tu negocio?
            </p>
            <h2 className="mt-3 text-3xl font-bold text-white md:text-4xl" data-id="element-849">
              Recibí un diagnóstico digital gratuito.
            </h2>
            <p className="mt-4 max-w-2xl leading-relaxed text-[#a9a9ba]" data-id="element-850">
              Revisamos la presencia actual de tu negocio y te mostramos qué
              información, funciones y estructura debería tener tu página.
            </p>
            <a href={createWhatsAppUrl(WHATSAPP_MESSAGES.diagnostic)} target="_blank" rel="noopener noreferrer" onClick={() => trackEvent('diagnostic_click', {
            cta_location: 'diagnostic'
          })} className="mt-6 inline-flex min-h-12 items-center justify-center gap-2 rounded-xl border border-[#20d6e8]/35 bg-[#20d6e8]/10 px-6 py-3 font-semibold text-[#d7fbff] transition-colors hover:bg-[#20d6e8]/20 focus:outline-none focus-visible:ring-2 focus-visible:ring-[#20d6e8]" data-id="element-851">
              <MessageCircleIcon className="h-5 w-5 text-[#20d6e8]" data-id="element-852" />
              Solicitar diagnóstico
            </a>
          </div>

          <ul className="space-y-3 rounded-xl border border-white/10 bg-black/10 p-5" data-id="element-853">
            {benefits.map(benefit => <li key={benefit} className="flex gap-3 text-sm leading-relaxed text-[#d5d5df]" data-id="element-854">
                <CheckIcon className="mt-0.5 h-4 w-4 flex-none text-[#25d366]" data-id="element-855" />
                {benefit}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}